import {
    Component,
    HostListener,
    Input
} from '@angular/core';
import { Layout } from '../../baseObjects/layout';

@Component({
    selector: 'slideshow',
    templateUrl: 'slideshow.component.html',
    host: { 'class': 'slideshow component' }
})
export class SlideShowComponent extends Layout {
    // properties
    private _slideInterval: any;

    // io
    @Input() showNavigationButtons: boolean;
    @Input() transitionInterval: number = 1000; 

    private _currentImageIndex: number;
    get currentImageIndex(): number {
        return this._currentImageIndex;
    }
    set currentImageIndex(value: number) {
        if (this.imageUrls) {
            this._currentImageIndex = value < 0 ? this.imageUrls.length - 1 : value > this.imageUrls.length - 1 ? 0 : value;
        }
    }
    /*
     * Specifies the images that will be shown
     */
    private _imageUrls: string[];
    get imageUrls(): string[] {
        return this._imageUrls;
    }
    @Input() set imageUrls(value: string[]) {
        this._imageUrls = value;
        if (value) {
            this.currentImageIndex = 0;
        }
    }

    // host listeners
    @HostListener('mouseover') onMouseHover() {
        if (this._slideInterval) {
            window.clearInterval(this._slideInterval);
        }
        this._slideInterval = setInterval(() => {
            this.currentImageIndex++;
        }, this.transitionInterval);
    }

    @HostListener('mouseleave') onMouseLeave() {
        window.clearInterval(this._slideInterval);
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/slideshow/slideshow.component.ts